import { ReactComponent as SearchIcon } from "../../../assets/icons/search.icon.svg";
const DEFAULT_CLASSNAMES = {
  td: "w-full",
  input:
    "w-full h-[36px] focus:font-ubuntuBold focus:text-secondary font-ubuntuRegular shadow text-center p-1 rounded",
};

const TableTextInput = ({
  value = "",
  classNames = DEFAULT_CLASSNAMES,
  handleSearch = () => {},
  search = false,
  ...otherProps
}) => {
  return (
    <td className={classNames.td}>
      <div className="relative">
        <input
          value={value || ""}
          type="text"
          {...otherProps}
          className={classNames.input}
        />
        {search ? (
          <SearchIcon
            onClick={() => handleSearch(value)}
            className="flex absolute fill-secondary top-[-6px] right-1 bg-greenGlass hover:bg-primary rounded p-1 cursor-pointer shadow-sm shadow-black backdrop-blur-sm"
          />
        ) : null}
      </div>
    </td>
  );
};

export default TableTextInput;
